import {all, put, select, takeLatest} from 'redux-saga/effects';
import {
	DEACTIVATE_SERIAL_NO_IN_ERP,
	FACTORY_RESTORE,
	FORCE_SETTINGS,
	REBOOT,
	REQUEST_FIRMWARE,
	REQUEST_LOCATION,
	SAVE_DEVICE, SAVE_DEVICES,
	SELECT_DEVICE,
	SEND_COMMAND,
	SEND_MESSAGE,
	SEND_SERVER_CONFIG,
	SEND_SMS,
	SET_DEVICE_MIGRATION_STEP,
	SHUT_DOWN, UPDATE_TEST_MODE,
	WS_DATA_DEVICE,
} from '../constants/device.constants';
import {DeviceAPI} from '../../utils/API/DeviceAPI';
import {selectDevices, selectMigratingDeviceId, selectSelectedDevice} from '../selectors/device.selector';
import {reselectDevice} from '../actions/device.actions';
import {selectBeacon} from '../actions/beacon.actions';
import {selectBeacons} from '../selectors/beacon.selector';
import {selectCurrentUser} from "../selectors/app.selectors";
import {APP_MOUNTED, USER_CHANGED} from "../constants/app.constants";
import Device from "../../utils/models/Device";
import SimAPI from "../../utils/API/SimAPI";
import SimCard from "../../utils/models/SimCard";
import {RETIRE_SIM_CARD} from "../../containers/SimCardPage/constants";
import {logout} from "../actions/app.actions";

const deviceApi = new DeviceAPI();
const simApi = new SimAPI();

function* saveDevicesSaga({devices}) {
	yield all(devices.map(device => deviceApi.saveDevice(device)));
}
function* saveDeviceSaga({device}) {
	yield deviceApi.saveDevice(device);
}

function* sendMessageSaga({message, devices, silent}) {
	yield deviceApi.sendMessage(message, devices, silent);
}

function* sendCommandSaga({command, device}) {
	yield deviceApi.sendCommand(command, device);
}
function* sendSMSSaga({command, device}) {
	yield deviceApi.sendSMS(command, device);
}

function* sendServerConfigSaga({device, config}) {
	if(config?.toJS) config = config.toJS();
	if(device.toJS) device = device.toJS();
	yield deviceApi.sendServerConfig({
		...(config || device),
		id: device.id
	});
}

function* requestLocationSaga({device}) {
	yield deviceApi.requestLocation(device);
}

function* requestFirmwareSaga({device}) {
	yield deviceApi.requestFirmware(device);
}

function* rebootSaga({device}) {
	yield deviceApi.reboot(device);
}

function* _reselectDeviceSaga() {
	const selectedDevice = yield select(selectSelectedDevice);
	yield put(reselectDevice(selectedDevice));
}

function* getStatusSaga() {
	const device = yield select(selectSelectedDevice);
	const selectedDeviceId = localStorage.getItem('selectedDeviceId');
	if(device && +device.id !== +selectedDeviceId) {
		localStorage.setItem('selectedDeviceId', device.id);
		yield deviceApi.getStatus(device);
	} else {
		localStorage.removeItem('selectedDeviceId');
	}
}

function *selectBeaconForDeviceSaga() {
	const device = yield select(selectSelectedDevice);
	if(device && device.get('beaconIds') && device.get('beaconIds').length) {
		const beacons = yield select(selectBeacons);
		const beacon = beacons.find(b => +b.id === +device.get('beaconIds')[0]);
		yield put(selectBeacon(beacon));
	}
}

function* forceSettingsSaga({device, onlyFailed}) {
	yield deviceApi.forceSettings(device, onlyFailed);
}
function *shutDownSaga({device}) {
	yield deviceApi.shutDown(device.id);
}
function *factoryRestoreSaga({device}) {
	yield deviceApi.factoryRestore(device.id);
}
function* getDeviceProtocolsSaga() {
	if(Device.protocols) return;
	const user = yield select(selectCurrentUser);
	if(!user) return;
	Device.protocols = yield deviceApi.getDeviceProtocols();
}

function* setDeviceMigrationStepSaga({step}) {
	const deviceId = yield select(selectMigratingDeviceId);
	yield deviceApi.setDeviceMigrationStep(deviceId, step);
}

function *deactivateSerialNoInERPSaga({device, date, reason}) {
	yield fetch('https://admin.vevigo.nl/pub/erpnext/serialNo/deactivate', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			serialNo: device.get('uniqueId'),
			date,
			reason
		})
	});
}
function* retireSimCardSaga({simCard, callback}) {
	const newSim = yield simApi.retireSimCard(simCard.iccid, null);
	callback(new SimCard(newSim));
}

function *updateTestMode({deviceIds, testMode}) {
	const devices = yield select(selectDevices);
	yield deviceApi.updateTestMode(
		devices
			.filter(d => deviceIds.indexOf(d.id) >= 0)
			.map(d => d.updateTestMode(testMode)
	));
}

function *checkForUserRolesSaga({user}) {
	if(!user) user = yield select(selectCurrentUser);
	if(user.isAppOnly) {
		return yield put(logout(false, {
			redirect: '/?msg=sso.error.noRoles&type=warning'
		}));
	}
}

export const deviceSagas = [
	takeLatest(APP_MOUNTED, getDeviceProtocolsSaga),
	takeLatest(USER_CHANGED, getDeviceProtocolsSaga),
	
	takeLatest(USER_CHANGED, checkForUserRolesSaga),
	takeLatest(APP_MOUNTED, checkForUserRolesSaga),
	
	takeLatest(WS_DATA_DEVICE, _reselectDeviceSaga),
	takeLatest(SAVE_DEVICE, saveDeviceSaga),
	takeLatest(SAVE_DEVICES, saveDevicesSaga),
	takeLatest(SEND_MESSAGE, sendMessageSaga),
	takeLatest(SEND_COMMAND, sendCommandSaga),
	takeLatest(SEND_SMS, sendSMSSaga),
	takeLatest(SEND_SERVER_CONFIG, sendServerConfigSaga),
	takeLatest(DEACTIVATE_SERIAL_NO_IN_ERP, deactivateSerialNoInERPSaga),
	takeLatest(REQUEST_LOCATION, requestLocationSaga),
	takeLatest(REQUEST_FIRMWARE, requestFirmwareSaga),
	takeLatest(SELECT_DEVICE, getStatusSaga),
	takeLatest(SELECT_DEVICE, selectBeaconForDeviceSaga),
	takeLatest(REBOOT, rebootSaga),
	takeLatest(FORCE_SETTINGS, forceSettingsSaga),
	takeLatest(SHUT_DOWN, shutDownSaga),
	takeLatest(FACTORY_RESTORE, factoryRestoreSaga),
	takeLatest(UPDATE_TEST_MODE, updateTestMode),
	takeLatest(SET_DEVICE_MIGRATION_STEP, setDeviceMigrationStepSaga),
	takeLatest(RETIRE_SIM_CARD, retireSimCardSaga)	
];